import { Component } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { HeaderComponent } from './common/header/header.component';
import { FooterComponent } from './common/footer/footer.component';
import { CommonModule } from '@angular/common';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { GlobalService } from './service/global.service';
import { HttpService } from './service/http.service';
import { SeoService } from './service/seo.service';
import { PreloaderComponent } from './modules/preloader/preloader.component';
import * as AOS from 'aos';
import { ActiveCallChatStripComponent } from './modules/active-call-chat-strip/active-call-chat-strip.component';
import { CarouselModule } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [PreloaderComponent,
    HeaderComponent,
    RouterOutlet,
    FooterComponent,
    CommonModule, NgxIntlTelInputModule,ActiveCallChatStripComponent,CarouselModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {

  hostname: string = '';

  isFooterVisible: boolean = true;
  isHeaderVisible: boolean = true;

  /** Routes rendered inside the dashboard shell — the marketing header/footer are hidden here. */
  private readonly dashboardRoutes: string[] = [
    'dashboard',
    'userdetailPage',
    'recharge-wallet',
    'customer-product-order-history',
    'customer-transactions-history',
    'customer-chat-order-history',
    'customer-call-order-history',
    'my-offers',
    'support-chat',
  ];
  constructor(private router: Router, public gS: GlobalService, private _homeService: HttpService, private seo: SeoService) {

    // Apply SEO meta (title/description/keywords/OG) per route for all public pages
    this.seo.init();

    this.hostname = window.location.hostname;
    console.log(this.hostname, 'urldata');
    if (this.hostname == "legalstack.live") {
      window.location.href = "https://legalstack.in";
    }
    router.events.subscribe(event => {


      if (event instanceof NavigationEnd) {

        let currentPage = event.url.split('?')[0];

        if (currentPage == '/search' || currentPage == '/chat-window' || currentPage == '/customer-product-order-history' || currentPage == '/support-chat') {
          this.isFooterVisible = false;
        } else {
          this.isFooterVisible = true;

        }

        // Hide the marketing header inside the post-login dashboard shell
        this.isHeaderVisible = !this.dashboardRoutes.includes(currentPage.replace(/^\//, ''));
        if (!this.isHeaderVisible) {
          this.isFooterVisible = false;
        }
        console.log(this.isFooterVisible);
      }
    });

    // this.registerServiceWorker();
  }
  title = 'legalStack';

 async ngOnInit() {
    let userData = this.gS.getUserDataFromStorage();
    if (userData) {
      this.gS.userData = userData;
      this._homeService.getUserWalletAmount(this.gS.userData?.id, 0).subscribe((data) => {
        let value: any = data;
        let totalWalletAmount = value.availableBalance;
        this.gS.userBalance = totalWalletAmount;
      }, (error) => {
        console.log(error);
      });
    }

    await this.gS.getTimeZone().then((timeZone: any) => {
      console.log('time zone=>',timeZone);
      if ((timeZone.toLowerCase() === 'Asia/Kolkata'.toLowerCase()) || (timeZone.toLowerCase() === 'Asia/Calcutta'.toLowerCase())) {
        this.gS.currencySign = '₹';
        this.gS.currencyType = 'INR';
        this.gS.indiaTimezone = true;
      } else {
        this.gS.currencySign = '$';
        this.gS.currencyType = 'USD';
        this.gS.indiaTimezone = false;
      }
    });

    AOS.init({
      duration: 1000,
      once: true   
    });
  }
}
